import { styled } from '@classify/react-core-components/styles';
import Loader from '../Loader';

const Root = styled('div')(() => ({
  display: 'flex',
  height: '100vh',
  width: '100%',
  justifyContent: 'center',
  alignItems: 'center',
}));

export interface Props {
  isSmall?: boolean;
}

const PageLoading = ({ isSmall }: Props) => (
  <Root data-testid="PageLoading">
    <Loader {...(isSmall ? {} : { isBig: true })} />
  </Root>
);

export default PageLoading;
